import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CalendarLoader from "../common-components/CalendarLoader.jsx";
import { CalenderIcon } from "../../images/icons/icons";

const BCAStatCards = ({ setFilters, selectedRange }) => {
  const { bcaStats, bcaStatsLoading, bcaStatsError } = useSelector(
    (state) => state.prospects
  );

  const [statsData, setStatsData] = useState(null);

  useEffect(() => {
    if (!bcaStatsLoading && !bcaStatsError && bcaStats?.status) {
      setStatsData(bcaStats?.data);
    } else {
      setStatsData(null);
    }
  }, [bcaStatsLoading, bcaStatsError, bcaStats]);

  const getCardTitle = (key) => {
    const titles = {
      "0-7_days": "0-7 Days Pending",
      "7-14_days": "7-14 Days Pending",
      "14-21_days": "14-21 Days Pending",
      "21-30_days": "21-30 Days Pending",
      ">30_days": ">30 Days Pending",
      total_pending: "Total Pending",
    };
    return titles[key] || key;
  };

  const getCardIcon = (key) => {
    const icons = {
      total_pending: <CalenderIcon />,
    };
    return icons[key] || <CalenderIcon />;
  };

  const getCardIconType = (key) => {
    const types = {
      total_pending: "info",
    };
    return types[key] || "danger";
  };

  const handleCardClick = (key, value) => {
    if (value > 0) {
      const rangeValue = key.replace("_days", "");

      if (key === "total_pending") {
        setFilters((prevs) => ({
          ...prevs,
          pending_days_range: "",
        }));
        return;
      }

      if (selectedRange === rangeValue) {
        setFilters((prevs) => ({
          ...prevs,
          pending_days_range: "",
        }));
        return;
      }

      setFilters((prevs) => ({
        ...prevs,
        pending_days_range: rangeValue,
      }));
    }
  };

  return (
    <div className="mr-kpi-grid mt30">
      {bcaStatsLoading ? (
        <CalendarLoader daysCount={6} shiftsPerDay={2} />
      ) : (
        statsData &&
        Object.entries(statsData)?.map(([key, value]) => {
          const isClickable = value > 0;
          const rangeValue = key.replace("_days", "");
          const isSelected = selectedRange === rangeValue;

          return (
            <div
              className={`mr-kpi-card ${
                isClickable ? "mr-kpi-card--clickable" : ""
              } ${isSelected ? "mr-kpi-card--selected" : ""}`}
              key={key}
              onClick={() => handleCardClick(key, value)}
              style={{
                cursor: isClickable ? "pointer" : "default",
                border: isSelected ? "2px solid #157EF9" : "1px solid #e0e0e0",
                boxShadow: isSelected
                  ? "0 4px 12px rgba(21, 126, 249, 0.2)"
                  : "none",
              }}
              title={isClickable ? `View ${getCardTitle(key)}` : ""}
            >
              <div className="mr-kpi-head">
                <div>
                  <p className="mr-kpi-title">{getCardTitle(key)}</p>
                  <div className="mr-kpi-value-row">
                    <div className="mr-kpi-value">{value}</div>
                  </div>
                </div>
                <span
                  className={`mr-kpi-icon mr-kpi-icon--${getCardIconType(key)}`}
                >
                  {getCardIcon(key)}
                </span>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default BCAStatCards;
